import type { ReportFilterState } from './types';

export const EMPTY_REPORT_FILTERS: ReportFilterState = {
  period: 'this_month',
  customFrom: null,
  customTo: null,
  practitionerIds: [],
  serviceIds: [],
  locationIds: [],
  appointmentStatus: 'completed',
  revenueBasis: 'invoiced',
  grouping: 'practitioner',
  patientIds: [],
  invoiceStatuses: [],
  paymentMethods: [],
  newVsReturning: 'all',
  includeCancelled: false,
  includeNoShows: false,
  minRevenueCents: null,
  maxRevenueCents: null,
};

export function countActiveMoreFilters(
  filters: ReportFilterState,
  defaults: Pick<ReportFilterState, 'grouping'> = EMPTY_REPORT_FILTERS,
): number {
  let count = 0;
  if (filters.locationIds.length > 0) count += 1;
  if (filters.appointmentStatus !== EMPTY_REPORT_FILTERS.appointmentStatus) count += 1;
  if (filters.revenueBasis !== EMPTY_REPORT_FILTERS.revenueBasis) count += 1;
  if (filters.grouping !== defaults.grouping) count += 1;
  if (filters.patientIds.length > 0) count += 1;
  if (filters.invoiceStatuses.length > 0) count += 1;
  if (filters.paymentMethods.length > 0) count += 1;
  if (filters.newVsReturning !== 'all') count += 1;
  if (filters.includeCancelled) count += 1;
  if (filters.includeNoShows) count += 1;
  if (filters.minRevenueCents != null) count += 1;
  if (filters.maxRevenueCents != null) count += 1;
  return count;
}

export function countActivePrimaryFilters(filters: ReportFilterState): number {
  let count = 0;
  if (filters.practitionerIds.length > 0) count += 1;
  if (filters.serviceIds.length > 0) count += 1;
  if (filters.period !== 'this_month') count += 1;
  return count;
}

export function countActiveFilters(
  filters: ReportFilterState,
  defaults: Pick<ReportFilterState, 'grouping'> = EMPTY_REPORT_FILTERS,
): number {
  return countActivePrimaryFilters(filters) + countActiveMoreFilters(filters, defaults);
}

export function clearMoreFilters(
  filters: ReportFilterState,
  defaults: Pick<ReportFilterState, 'grouping'> = EMPTY_REPORT_FILTERS,
): ReportFilterState {
  return {
    ...filters,
    locationIds: [],
    appointmentStatus: EMPTY_REPORT_FILTERS.appointmentStatus,
    revenueBasis: EMPTY_REPORT_FILTERS.revenueBasis,
    grouping: defaults.grouping,
    patientIds: [],
    invoiceStatuses: [],
    paymentMethods: [],
    newVsReturning: 'all',
    includeCancelled: false,
    includeNoShows: false,
    minRevenueCents: null,
    maxRevenueCents: null,
  };
}

export function clearAllReportFilters(): ReportFilterState {
  return { ...EMPTY_REPORT_FILTERS };
}

export function filtersHaveChanges(
  filters: ReportFilterState,
  baseline: ReportFilterState = EMPTY_REPORT_FILTERS,
): boolean {
  return JSON.stringify(filters) !== JSON.stringify(baseline);
}
